import React from 'react';
import heroBg from '../assets/churro10.jpeg';
import './Hero.css';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">
      <img src={heroBg} alt="Churros ATX" className="hero__bg-image" />
      <div className="hero__overlay"></div>
      <div className="hero__split">
        <div className="hero__content">
          <span className="hero__badge">✦ Georgetown, Texas ✦</span>
          <h1 className="hero__title">
            <span className="hero__title-line">The Traditional Taste of Mexico</span>
            <span className="hero__title-accent">Hand-Made in Texas</span>
          </h1>
          <p className="hero__subtitle">
            Churros & Empanadas — Crafted From Scratch, Served With Love
          </p>
          <p className="hero__description">
            Every Churros ATX treat is hand-pressed with love using family recipes 
            and local ingredients. We don't just make churros — we celebrate tradition, 
            one golden crunch at a time.
          </p>
          <div className="hero__actions">
            <button className="hero__btn hero__btn--primary" onClick={() => scrollToSection('menu')}>
              Explore Our Menu
            </button>
            <button className="hero__btn hero__btn--secondary" onClick={() => scrollToSection('catering')}>
              Catering &amp; Events
            </button>
          </div>
          <div className="hero__stats">
            <div className="hero__stat">
              <span className="hero__stat-number">100%</span>
              <span className="hero__stat-label">Hand-Pressed</span>
            </div>
            <div className="hero__stat-divider"></div>
            <div className="hero__stat">
              <span className="hero__stat-number">100%</span>
              <span className="hero__stat-label">Made From Scratch</span>
            </div>
            <div className="hero__stat-divider"></div>
            <div className="hero__stat">
              <span className="hero__stat-number">100%</span>
              <span className="hero__stat-label">Vegan Churros</span>
            </div>
          </div>
        </div>
        <div className="hero__map">
          <div className="hero__map-card">
            <div className="hero__map-embed">
              <iframe
                title="Churros ATX Location"
                src="https://maps.google.com/maps?q=1005+SE+Rock+St,+Georgetown,+TX+78626&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div className="hero__map-info">
              <p className="hero__map-address">📍 1005 SE Rock St Georgetown TX. 78626</p>
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=1005+SE+Rock+St,+Georgetown,+TX+78626"
                target="_blank"
                rel="noopener noreferrer"
                className="hero__map-btn"
              >
                Take Me There! →
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="hero__scroll-indicator">
        <span>Scroll Down</span>
        <div className="hero__scroll-arrow"></div>
      </div>
    </section>
  );
};

export default Hero;
